import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "../../Elements/Modal/Modal";
import MainButton from "../../Elements/MainButton/MainButton";
import SecondButton from "../../Elements/SecondButton/SecondButton";
import trashIcon from "../../../assets/icons/trash.png";
import "./AddedToCartModal.css";

const AddedToCartModal = ({ isOpen, onClose, onGoToCart, onRemoveItem, items = [] }) => {
  const currency = (value, cur = "USD") => {
    if (value == null) return "";
    return `${value.toFixed(2)} ${cur}`;
  };

  const sortedItems = [...items].sort((a, b) => (b.lastAddedAt || 0) - (a.lastAddedAt || 0));
  const grandTotal = sortedItems.reduce((sum, item) => sum + (item.price || 0) * (item.quantity || 1), 0);

  useEffect(() => {
    if (isOpen && items.length === 0) {
      onClose();
    }
  }, [isOpen, items.length, onClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Added to cart"
      actions={
        <>
          <SecondButton onClick={onClose}>Continue shopping</SecondButton>
          <MainButton onClick={onGoToCart}>Go to cart</MainButton>
        </>
      }
    >
      <div className="added-to-cart-body">
        <p className="added-to-cart-text">Your eSIM plan has been added to your cart.</p>

        <div className="added-to-cart-list">
          {sortedItems.map((item) => (
            <div key={item.id} className="added-to-cart-item">
              <div className="added-to-cart-item__name">{item.name}</div>

              <div className="added-to-cart-item__right">
                <div className="added-to-cart-item__calc">
                  {item.quantity || 1} × {currency(item.price, item.currency)}
                </div>

                <button
                  type="button"
                  className="added-to-cart-item__remove"
                  onClick={() => onRemoveItem(item.id)}
                  aria-label="Remove from cart"
                >
                  <img src={trashIcon} alt="" className="added-to-cart-item__remove-icon" />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="added-to-cart-summary">
          <span className="added-to-cart-summary__label">Total</span>
          <span className="added-to-cart-summary__value">
            {currency(grandTotal, sortedItems[0]?.currency || "USD")}
          </span>
        </div>
      </div>
    </Modal>
  );
};

AddedToCartModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onGoToCart: PropTypes.func.isRequired,
  onRemoveItem: PropTypes.func.isRequired,
  items: PropTypes.array,
};

export default AddedToCartModal;
